export default {
  data: null,
  columns: [
    {
      label: '姓名',
      prop: 'userName'
    },
    {
      label: '账号',
      prop: 'account'
    },
    {
      label: '比赛类别',
      prop: '__busType__'
    },
    {
      label: '主办方',
      prop: 'orgName'
    },
    {
      label: '比赛名称',
      prop: 'busName'
    },
    {
      label: '比赛ID',
      prop: 'busId'
    },
    {
      label: '申请时间',
      prop: 'createTime'
    },
    {
      label: '支付金额(元)',
      prop: 'payAmount'
    },
    {
      label: '退款比例(%)',
      prop: 'refundScale'
    },
    {
      label: '退款金额(元)',
      prop: 'refundAmount'
    },
    {
      label: '状态',
      prop: '__payStatus__'
    },
    {
      label: '退款原因',
      prop: 'refundDesc'
    },
    {
      label: '备注',
      prop: 'remark'
    }
  ]
}
